// Simple Google Analytics (GA4) helper
// Replace the GA_MEASUREMENT_ID with your Measurement ID (G-XXXXXXXXXX)
const GA_MEASUREMENT_ID = 'G-639DH3ZN1G';


export function initGA() {
  // If gtag is already available (loaded from index.html), configure it.
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function(){window.dataLayer.push(arguments)};
  try {
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, { anonymize_ip: true });
  } catch (e) {
    // ignore in environments where gtag isn't loaded yet
  }
}

export function trackEvent(action, category, label, value) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value
  });
}

const analytics = { initGA, trackEvent };
export default analytics;
